// DS: B16
import React from 'react';
import classnames from 'classnames';
import Plus from '../../Icons/Plus';
import { IconSize } from '../../Icons/IconWrap';
import Check from '../../Icons/Check';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import { BiDataHook } from '../../biLogger/constants';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './AuthorWatchButton.scss';
export var AuthorWatchButton = function (_a) {
    var author = _a.author, className = _a.className, children = _a.children, onWatch = _a.onWatch, iconClassName = _a.iconClassName, isWatchingBack = _a.isWatchingBack, watchingClassname = _a.watchingClassname, disabled = _a.disabled, onToggleWatchSuccess = _a.onToggleWatchSuccess;
    var _b = useWatchButton(author, author === null || author === void 0 ? void 0 : author.isWatching, isWatchingBack, disabled, onToggleWatchSuccess), onClick = _b.onClick, text = _b.text, isWatching = _b.isWatching, biData = _b.biData;
    return (React.createElement(PlainButtonOrLink, { biData: biData, className: classnames(s['root'], isWatching && s['watching'], isWatching && watchingClassname, className), onClick: function () {
            onClick();
            onWatch && onWatch();
        }, "data-hook": BiDataHook.USER_WATCH_BUTTON, disabled: disabled },
        React.createElement(Plus, { customSizable: true, className: classnames(s['plus-icon'], iconClassName), size: IconSize.SMALL }),
        isWatching && (React.createElement(React.Fragment, null,
            React.createElement(Check, { customSizable: true, className: classnames(s['check-icon'], iconClassName), size: IconSize.SMALL }))),
        children || text));
};
AuthorWatchButton.displayName = 'AuthorWatchButton';
export default AuthorWatchButton;
//# sourceMappingURL=AuthorWatchButton.js.map